import { SxProps } from '@mui/material'

const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  } as SxProps
}

export default styles
